import React from "react";
import { Button, Container, SideBar } from "../../Styles/Global.Styled";
import { css } from "styled-components";
import Filter from "./Filter";
import ClosePopupButton from "../Buttons/ClosePopupButton";

const displayHide = css`
  display: none;
`;
const SideBarStyle = css`
  overflow: auto;
  box-sizing: border-box;
  background-color: white;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 11;
  padding: 2vh 2vw;
`;
const mainBttn = css`
  position: fixed;
  background-color: ${({ theme }) => theme.main};
  border-radius: 50px;
  color: white;
  font-size: 2vh;
  padding: 1vh 0;
  bottom: 1vh;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 75%;
  z-index: 5;
`;
const mainCntStyle = css`
  flex-direction: column;
  /* border:2px solid red; */
  gap: 2vh;
  padding: 1vh 0 10vh 0;
`;

const MobileFilterBar = ({ setPopUp, fltr, setFilters, setProducts }) => {
  return (
    <SideBar $baseStyle={displayHide} $mStyle={SideBarStyle}>
      <ClosePopupButton setPopUp={setPopUp} />
      <Container $baseStyle={mainCntStyle}>
        {fltr?.map((filterType, index) => (
          <Filter
            key={filterType.name}
            isOpen={[0, 1].includes(index)}
            filterType={filterType}
            setFilters={setFilters}
          />
        ))}
      </Container>
      <Button $baseStyle={mainBttn}>Apply</Button>
    </SideBar>
  );
};

export default MobileFilterBar;
